import { atom } from "jotai";
import { User } from "@quantizr-engineering/common/types/user";

export const userAtom = atom<User>({
  email: "",
  password: "",
  firstName: "",
  lastName: "",
  teamName: "",
  userRole: [],
  teamMembers: [],
  numberOfMembers: "",
});

export const isAuthenticatedAtom = atom<boolean>(false);

export const isLoadingUserAtom = atom<boolean>(false);

export const userErrorAtom = atom<string | null>(null);

export const userStatusAtom = atom({
  registration: null as string | null,
  creation: null as string | null,
  update: null as string | null,
  deletion: null as string | null,
});

// Derived atom to get the full name of the user
export const userFullNameAtom = atom((get) => {
  const user = get(userAtom);
  return user ? `${user.firstName} ${user.lastName}` : "";
});

export const updateUserStatusAtom = atom(
  null,
  (
    get,
    set,
    update: Partial<{
      registration: string | null;
      creation: string | null;
      update: string | null;
      deletion: string | null;
    }>
  ) => {
    const currentStatus = get(userStatusAtom);
    set(userStatusAtom, { ...currentStatus, ...update });
  }
);

//Signup validation 
export const signUpValidationAtom = atom<{ [key: string]: string }>({});

//Reset Password
export const resetPasswordAtom = atom({
  email: "",
  password: "",
  rememberMe: false 
});
